import { components40Names } from "../v40/components.enum";

export const componentsInspectionlessV11Names = components40Names;
